import { render } from "./FamiliesCollections.vue?vue&type=template&id=7259fef4&scoped=true"
import script from "./FamiliesCollections.vue?vue&type=script&lang=js"
export * from "./FamiliesCollections.vue?vue&type=script&lang=js"

import "./FamiliesCollections.vue?vue&type=style&index=0&id=7259fef4&lang=scss&scoped=true"

import exportComponent from "H:\\_LK\\_FINISHED PROJECTS\\photographer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7259fef4"]])

export default __exports__